import React from 'react'
import coming from "../../assets/comingsoon.png"
import "../cards/tinycard.css"

function soon() {
    return (
        <div className="fl">
            <img className="mt-3 animate__animated animate__fadeInDownBig" src={coming}></img>
            <img className="mtwww5" src="https://media.giphy.com/media/6fScAIQR0P0xW/giphy.gif"></img>

        </div>
    )
}

export default soon
// https://media.giphy.com/media/6fScAIQR0P0xW/giphy.gif